import {css, useTheme} from '@mui/material';
import SvgIcon from '@mui/material/SvgIcon';
import React from 'react';

import calendarIcon from 'src/assets/icons/calendarIcon.svg';
import {GetStylesFunction} from 'src/js/common/types';

type Props = any;

export const DlMuiCalendarIcon: React.FC<Props> = (props) => {
  const theme = useTheme();
  const styles = getStyles({theme});

  return (
    <SvgIcon
      css={styles.calendarIcon}
      component={calendarIcon}
      inheritViewBox
      {...props}
    />
  );
};

DlMuiCalendarIcon.displayName = 'DlMuiCalendarIcon';

const getStyles: GetStylesFunction = (options) => ({
  calendarIcon: css`
    width: 16px;
    height: 16px;
    color: ${options?.theme?.palette.custom.coolGray['500']};
  `,
});
